export default "__VITE_ASSET__CTql_s5___"